import { getPortalId } from 'unified-navigation-ui/utils/getPortalId';
const isFromThisPortal = e => {
  return e.data.portalId === getPortalId();
};
export function isNotificationsMenuOpenedMessage(e) {
  return e.data.type === 'notifications-menu-opened' && isFromThisPortal(e);
}
export const broadcastNotificationMessage = message => {
  if ('BroadcastChannel' in window) {
    const portalId = getPortalId();
    const channel = new BroadcastChannel('notifications-events');
    if (typeof message === 'string') {
      channel.postMessage({
        portalId,
        type: message
      });
    }
    channel.close();
  }
};